import { useEditorStore } from "@/store/editorStore";
import { ChevronUp, ChevronDown, Copy, Plus, Trash2 } from "lucide-react";

export default function FloatingPageToolbar({ pageId, index, total }) {
  const movePage = useEditorStore((s) => s.movePage);
  const duplicatePage = useEditorStore((s) => s.duplicatePage);
  const addPage = useEditorStore((s) => s.addPage);
  const deletePage = useEditorStore((s) => s.deletePage);

  const Btn = ({ icon: Icon, onClick, label, disabled, danger, testId }) => (
    <button
      disabled={disabled}
      onClick={onClick}
      title={label}
      className={`w-9 h-9 rounded-md flex items-center justify-center hover:bg-gray-100 transition-colors ${
        danger ? "text-red-600 hover:bg-red-50" : "text-gray-700"
      } disabled:opacity-30 disabled:cursor-not-allowed`}
      data-testid={testId}
    >
      <Icon className="w-4 h-4" />
    </button>
  );

  return (
    <div className="absolute -right-12 top-2 flex flex-col gap-0.5 bg-white border border-gray-200 rounded-md shadow-md p-1 z-20" data-testid={`page-toolbar-${pageId}`}>
      <Btn icon={ChevronUp} onClick={() => movePage(pageId, "up")} label="Move page up" disabled={index === 0} testId={`page-move-up-${pageId}`} />
      <Btn icon={ChevronDown} onClick={() => movePage(pageId, "down")} label="Move page down" disabled={index === total - 1} testId={`page-move-down-${pageId}`} />
      <Btn icon={Copy} onClick={() => duplicatePage(pageId)} label="Duplicate page" testId={`page-duplicate-${pageId}`} />
      <Btn icon={Plus} onClick={() => addPage(pageId)} label="Add page below" testId={`page-add-${pageId}`} />
      <Btn icon={Trash2} onClick={() => deletePage(pageId)} label="Delete page" disabled={total === 1} danger testId={`page-delete-${pageId}`} />
    </div>
  );
}
